import { SEVERITY, type SeverityKey } from './severity';

interface SeverityPillProps {
    severity: SeverityKey;
    size?: 'sm' | 'xs';
}

function SeverityPill({ severity, size = 'sm' }: SeverityPillProps) {
    const s = SEVERITY[severity];
    return (
        <span
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md font-inter font-semibold ${
                size === 'xs' ? 'text-[10px]' : 'text-[11px]'
            } ${s.badgeBg}`}
        >
            <span className="w-1 h-1 rounded-full bg-current opacity-70" />
            {s.label}
        </span>
    );
}

export { SeverityPill };
